<button ngbDropdownItem type="button" (click)="displayImportDialog()">
  <cx-icon type="UPLOAD_BLUE"></cx-icon>
  {{ 'importExport.cart.import' | cxTranslate }}
</button>
